// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {586: "recorder",621: "profiler",}[chunkId] + "-internal-d41421c7-0d0f-4ffd-b59b-b3cc1b5229e4-" + {586: "ec0f4d9af9b39d4e",621: "0c9ff55f0aaaec3f",}[chunkId] + ".js"
}